import styled from "styled-components";
import { BREAKPOINT, COLORS, FONT_SIZE } from "../../../constants/Styles";

export const Container = styled.div`
  max-width: ${BREAKPOINT};
  margin-bottom: 2rem;
  @media (max-width: ${BREAKPOINT}) {
    width: 100%;
  }
`;

export const Header = styled.div`
  padding: 1rem;
  margin-bottom: 2rem;
`;

export const TitleBlock = styled.div`
  margin-bottom: 2rem;
`;

export const PostContainer = styled.div`
  margin-left: 1rem;
`;

export const Details = styled.div`
  display: flex;
  font-size: ${FONT_SIZE.size16};
  align-content: center;
`;

export const ByLine = styled.div`
  margin-left: 2rem;
  color: ${COLORS.secondaryLight};
  opacity: 0.5;
`;

export const Pill = styled.div`
  border-radius: 100px;
  background: rgba(255, 255, 255, 0.2);
  margin-right: 0.5rem;
  padding: 0 0.375rem;
`;
